import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
const SVG = styled.svg ``;
export function ArrowDownIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx(SVG, { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.777 11.135l-5.25 4.667A.767.767 0 0112 16a.767.767 0 01-.527-.198l-5.25-4.667A.608.608 0 016 10.667c0-.18.074-.337.223-.469A.768.768 0 016.75 10h10.5c.203 0 .379.066.527.198a.608.608 0 01.223.469c0 .18-.074.336-.223.468z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=ArrowDown.js.map